import moment from 'moment';

// 1:42:10 above an hour, 24:15 below.
export const formatCountdown = (totalSeconds) => {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  const pad = (n) => String(n).padStart(2, '0');
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
};

export const formatClockTime = (date) =>
  date ? moment(date).format('hh:mm A') : '';

export const formatDateTime = (date) =>
  date ? moment(date).format('DD MMM YYYY, hh:mm A') : '-';

export const formatMinutes = (minutes) => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (!h) return `${m} min`;
  return m ? `${h} hr ${m} min` : `${h} hr`;
};
